import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Table, Image, Modal, Button } from 'react-bootstrap';
import * as api from 'services/api';
import _ from 'lodash';
import './InterventionTypeList.css';
import { useTranslation } from 'react-i18next';

export function InterventionTypeList() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [types, setTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [typeIdToDelete, setTypeIdToDelete] = useState(null);
    const [integrationActions, setIntegrationActions] = useState([]);

    useEffect(() => {
        getInterventionTypes();
        getIntegrationActions();
    }, []);

    const getIntegrationActions = async () => {
        const actions = await api.getIntegrationActions();
        if (actions.status === 200) {
            setIntegrationActions(actions.data);
        } else {
            console.error(t('errorObtainingActions'));
        }
    };

    const getInterventionTypes = async () => {
        const response = await api.getInterventionTypes();
        if (response.status === 200) {
            setTypes(response.data);
        } else {
            console.error('Error al obtener el listado de usuarios');
        }
    };

    const handleEditInterventionType = (id) => {
        navigate(`/interventionTypeManagement/editInterventionType/${id}`);
    };

    const handleDeleteInterventionType = (id) => {
        setTypeIdToDelete(id);
        setShowModal(true);
    };

    const deleteUser = async () => {
        if (typeIdToDelete) {
            const response = await api.deleteInterventionType(typeIdToDelete);
            if (response.status === 200) {
                setShowModal(false);
                setTypeIdToDelete(null);
                getInterventionTypes();
            } else {
                console.error('Error al eliminar el usuario');
            }
        }
    };

    const getIntegrationActionsText = (value) => {

        if (integrationActions.length > 0) {
            const action = integrationActions.find(a => a.value === value);
            return action.value > 0 ? t(action.text) : '';
        } else {
            return '';
        }
    };

    return (
        <div className="InterventionTypeList">

            {types.length > 0 && (
                <div className="card rounded-3 overflow-auto p-2 mt-5">
                    <table className='table table-hover overflow-auto'>
                        <thead>
                            <tr>
                                <th>{t('it.Name')}</th>
                                <th>{t('it.Text')}</th>
                                <th>{t('it.IntegrationId')}</th>
                                <th>{t('it.UpdatePhone')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {types.map((type) => (
                                <tr key={type.id}>
                                    <td className="align-middle" style={{ color: type.enable ? 'black' : 'red' }}>{type.name}</td>
                                    <td className="align-middle" style={{ color: type.enable ? 'black' : 'red' }}>{type.text}</td>
                                    <td className="align-middle" style={{ color: type.enable ? 'black' : 'red' }}>{type.integrationId + '(' + getIntegrationActionsText(type.integrationId) + ')'}</td>
                                    <td className="align-middle" style={{ color: type.enable ? 'black' : 'red' }}>{type.updatePhone ? 'Sí' : 'No'}</td>
                                    <td className="align-middle">
                                        <Stack direction="horizontal" gap="3" className="justify-content-center">
                                            <Image src="./icons/edit.svg" className="UsersList__icons" onClick={() => handleEditInterventionType(type.id)} />
                                            <Image src="./icons/delete.svg" className="UsersList__icons" onClick={() => handleDeleteInterventionType(type.id)} />
                                        </Stack>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            )}


            {/* Modal para confirmar la eliminación del usuario */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('usConfirmDeletion')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('it.QuestionDeletion')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {t('usCancel')}
                    </Button>
                    <Button variant="danger" onClick={deleteUser}>
                        {t('usAccept')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}